export default __webpack_public_path__ + "static/team2-00ea01291a480b19c672e1e9cb5ab2c5.jpg";